import type { MeetingDoc } from "./meetingDocsEndpoint";

export type MeetingDocStatus = "pending" | "running" | "success" | "failed";

export const normalizeMeetingDocStatus = (status: unknown): MeetingDocStatus => {
  if (status === "pending" || status === "running" || status === "success" || status === "failed") {
    return status;
  }
  return "running";
};

export const isMeetingFollowupDoc = (docType: string | null | undefined) =>
  docType === "meeting_followup";

export const getMeetingDocLabel = (docType: string | null | undefined) => (
  isMeetingFollowupDoc(docType) ? "Follow-up" : "Prep"
);

export const getMeetingDocMarkdown = (
  doc: Pick<MeetingDoc, "content_markdown" | "content_payload"> | null | undefined,
): string | null => {
  if (!doc) return null;
  if (typeof doc.content_markdown === "string" && doc.content_markdown.trim()) {
    return doc.content_markdown;
  }

  const payload = doc.content_payload || {};
  const candidateKeys = [
    "brief_markdown",
    "prep_brief_markdown",
    "followup_brief_markdown",
    "summary_markdown",
    "markdown",
    "content",
  ];

  for (const key of candidateKeys) {
    const value = payload[key];
    if (typeof value === "string" && value.trim()) {
      return value;
    }
  }

  return null;
};
